import styled, { css, keyframes } from 'styled-components';

const heartBounce = keyframes`
  0% {
    transform: scale(1);
  }
  28% {
    transform: scale(1.35);
  }
  48% {
    transform: scale(0.88);
  }
  68% {
    transform: scale(1.12);
  }
  100% {
    transform: scale(1);
  }
`;

const sparklePop = keyframes`
  0% {
    opacity: 0;
    transform: translateY(0) scale(0.35);
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-220%) scale(1);
  }
`;

export const Button = styled.button.attrs<{ $liked: boolean }>(({ $liked }) => ({
  'data-liked': $liked ? 'true' : 'false',
  'aria-pressed': $liked ? 'true' : 'false',
}))<{ $liked: boolean }>(
  ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.neutral99};
    font-size: ${theme.sz.s6};
    cursor: pointer;
    overflow: visible;

    /* Unliked: dark outline heart. Liked: solid red heart. */
    &[data-liked='false'] {
      color: ${theme.co.secondary0};
    }

    &[data-liked='true'] {
      color: ${theme.co.error50};
    }

    &:hover {
      background-color: ${theme.co.neutral95};
    }

    svg {
      height: ${theme.sz.s6};
      width: ${theme.sz.s6};
    }
  `,
);

export const HeartIconWrap = styled.span<{ $celebrating?: boolean }>(
  ({ $celebrating }) => css`
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    ${
      $celebrating &&
      css`
        animation: ${heartBounce} 480ms cubic-bezier(0.34, 1.4, 0.64, 1) both;

        @media (prefers-reduced-motion: reduce) {
          animation: none;
        }
      `
    }
  `,
);

export const Sparkle = styled.span<{ $index: number; $count: number }>(
  ({ theme, $index, $count }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    transform: rotate(${($index / $count) * 360}deg);
    pointer-events: none;

    &::after {
      display: block;
      width: ${theme.sz.s1};
      height: ${theme.sz.s1};
      margin: 0 auto;
      border-radius: ${theme.bo.round};
      background-color: ${$index % 2 === 0 ? theme.co.primary20 : theme.co.error50};
      content: '';
      animation: ${sparklePop} 560ms ease-out ${$index * 30}ms both;
    }

    @media (prefers-reduced-motion: reduce) {
      display: none;
    }
  `,
);
